import React, { Component } from 'react';
import { Form, Icon, Input, Button, Checkbox } from 'antd';
import { dispatch } from '@@/store';
import { connect, router } from '@souche-f2e/muji';
import { load, save } from '../../utils/localstore';
import { withRouter } from '@souche-f2e/muji';

import styles from './index.module.less';

@withRouter
class LoginForm extends Component {
    componentDidMount() {
        save('user', null);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }
            const { userid: username, password: password } =values;
            dispatch.user.login({ username, password });
        });
    }

    render() {
        const { loginErrMsg, isLogin } = this.props;
        const FormItem = Form.Item;
        const { getFieldDecorator } = this.props.form;

        if (isLogin) {
            this.props.router.push('/Home');
        }

        return (
            <div className={styles.loginWrap}>
                <p className={styles.loginHead}>
                    用户登录
                </p>
                <Form onSubmit={this.handleSubmit} className={styles.loginForm}>
                    <FormItem>
                        {
                            getFieldDecorator('userid', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入用户名'
                                    }
                                ]
                            })(
                                <Input
                                    prefix={<Icon type="user" />}
                                    placeholder="用户名" />
                            )
                        }
                    </FormItem>
                    <FormItem>
                        {
                            getFieldDecorator('password', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入密码'
                                    }
                                ]
                            })(
                                <Input
                                    prefix={<Icon type="lock" />}
                                    type="password"
                                    placeholder="请输入密码" />
                            )
                        }
                    </FormItem>
                    <FormItem>
                        <Button type="primary" htmlType="submit" className={styles.loginBtn}>
                            登录
                        </Button>
                    </FormItem>
                    <FormItem className={styles.loginerrormsg}>
                        <p>{loginErrMsg}</p>
                    </FormItem>
                    <FormItem className={styles.loginLinks}>
                        {/*<a href="">忘记密码</a>*/}
                        {/*<a herf="">忘记会员名</a>*/}
                        {/*<a href="">免费注册</a>*/}
                        <a href="">自助注册暂未开放，请联系对接人员获取账号</a>
                    </FormItem>
                </Form>
            </div>

        );
    }
}

const WrappedLoginForm = Form.create()(LoginForm);

const mapStateToProps = (state, ownProps) => {
    return {
        loginErrMsg: state.user.loginErrMsg,
        isLogin: state.user.isLogin,
    }
}

export default connect(mapStateToProps)(WrappedLoginForm);
